import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/aboutus.css";
import { aboutUs } from "../../data/aboutUs";
import { SERVICES } from "../homepage/OurServices";
import ServicePrism from "../homepage/ServicePrism";

// The page's own heading copy beside the same service prism as the homepage;
// picking a service opens its page.
const AboutUsWhatWeDo = () => {
  const navigate = useNavigate();
  const { title, description } = aboutUs.whatWeDo;

  return (
    <section className="aboutus_wwd_heading_section">
      <div className="aboutus_wwd_inner">
        <div className="wwd-grid">
          <div className="aboutus_wwd_heading" data-aos="fade-up">
            <h2 className="aboutus_wwd_heading_title">{title}</h2>
            <p className="aboutus_wwd_heading_desc">{description}</p>
          </div>

          <div data-aos="fade-up" data-aos-delay="150">
            <ServicePrism onOpen={(i) => navigate(SERVICES[i].to)} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsWhatWeDo;
